/* import __COLOCATED_TEMPLATE__ from './unified-withholding-bps-text.hbs'; */
var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@ember/component';
import { computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { WithholdingLevel, getMostRecentConfigs, isMerchantWithholding } from '@banking/api/utils/unified-account';
let UnifiedWithholdingBpsText = (_dec = computed('account.withholdingLevel', 'config.withholdingConfigs'), _dec2 = computed('account.{maxUnitWithholdingBps,minUnitWithholdingBps}'), _dec3 = computed('account.minUnitWithholdingBps'), _class = class UnifiedWithholdingBpsText extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "automationSubaccountState", _descriptor, this);
    _initializerDefineProperty(this, "features", _descriptor2, this);
    _initializerDefineProperty(this, "intl", _descriptor3, this);
    _defineProperty(this, "account", void 0);
    _defineProperty(this, "config", void 0);
  }
  get merchantLevelWithholding() {
    if (this.account.withholdingLevel) {
      return this.account.withholdingLevel === WithholdingLevel.MERCHANT;
    } else {
      if (this.config && 'withholdingConfigs' in this.config) {
        const mostRecent = getMostRecentConfigs(this.config?.withholdingConfigs);
        if (mostRecent[0]) {
          return isMerchantWithholding(mostRecent[0]);
        } else {
          return true;
        }
      } else {
        return true;
      }
    }
  }
  get hasWithholdingBpsRange() {
    return Boolean(this.account?.minUnitWithholdingBps !== undefined && this.account?.maxUnitWithholdingBps !== undefined && this.account.minUnitWithholdingBps !== this.account.maxUnitWithholdingBps);
  }
  get minBpsWithoutPercentageSign() {
    if (this.account?.minUnitWithholdingBps === undefined) {
      return undefined;
    }
    return this.intl.formatNumber(this.account.minUnitWithholdingBps / 100);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "automationSubaccountState", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "features", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "merchantLevelWithholding", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "merchantLevelWithholding"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasWithholdingBpsRange", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "hasWithholdingBpsRange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "minBpsWithoutPercentageSign", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "minBpsWithoutPercentageSign"), _class.prototype), _class);
export { UnifiedWithholdingBpsText as default };